import { QRCodeSVG } from "qrcode.react";

import { useCongress } from "@/features/congress-select/hooks/use-congress";
import { useToast } from "@/hooks/use-toast";
import { useTranslation } from "react-i18next";

export function CongressPreview() {
  const { t } = useTranslation();
  const { congress } = useCongress();
  const { toast } = useToast();

  return (
    <div className="full space-y-4 rounded-md border p-2">
      <p className="text-center text-sm">{t("preview.testTicket")}</p>
      <QRCodeSVG value={`preview:${congress?.id}`} className="mx-auto w-full" />

      <div>
        <button
          className="w-full rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground"
          onClick={() => {
            navigator.clipboard.writeText(`preview:${congress?.id}`);
            toast({
              title: t("preview.copied"),
            });
          }}
        >
          {t("common.copy")}
        </button>
      </div>
    </div>
  );
}
